// history.js
import { createBrowserHistory } from 'history';

export const history = createBrowserHistory({
  /* pass a configuration object here if needed */
});
